import React from 'react'
import TradePortal from '@/components/SHARED/trade-portal/trade-portal.component'

const PlayerTradePortal = ({ gameData, playerData, gameElements, teamMembers }) => {
    return (
        <TradePortal
            isManager={false}
            gameData={gameData}
            playerData={playerData}
            gameElements={gameElements}
            teamMembers={teamMembers}
        />
    )
}

export default PlayerTradePortal
